import { render, staticRenderFns } from "./HomepageBooks.vue?vue&type=template&id=56392c79&scoped=true"
var script = {}
import style0 from "./HomepageBooks.vue?vue&type=style&index=0&id=56392c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56392c79",
  null
  
)

export default component.exports